<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="关键字" name='keyword'>
      <a-input v-model:value="search.keyword" :style="{width:'300px'}" placeholder="请输入门店编号/名称/手机号码进行搜索" />
    </a-form-item>
    <a-form-item label="状态" name='status' v-if='open'>
      <a-select v-model:value="search.status" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option value="0">待审核</a-select-option>
        <!-- <a-select-option value="1">审核通过</a-select-option> -->
        <a-select-option value="2">审核不通过</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="门店类型/级别" name='' v-if='open'>
      <a-select v-model:value="search.type_id" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option v-for='item in typeList' :key='item.type_id' :value="item.type_id">{{item.type_name}}
        </a-select-option>
      </a-select>
      <a-select class="m-l-20" v-model:value="search.level_id" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option v-for='item in levelList' :key='item.id' :value="item.id">{{item.level_name}}</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="门店地址" name='' v-if='open'>
      <selectCity class="m-r-20" v-on:citychange='citychange' placeholder='请选择门店地址'></selectCity>
    </a-form-item>
    <a-form-item label="" name='' v-if='open'>
      <a-input v-model:value="search.street" :style="{width:'300px'}" placeholder="请输入详细地址" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
    <!-- <a-form-item>
      <a-button type="primary" ghost>导入</a-button>
    </a-form-item> -->
    <a-form-item>
      <a href="javascript:;" @click='open = !open'>{{open ? '收起':'展开'}}</a>
      <UpOutlined v-if='open'/>
      <DownOutlined  v-else/>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' :scroll="{ x: 'max-content'}" class='tableFixBox'>
    <template v-slot:type="{ record }">
      <p>{{record.level_name}}/{{record.type_name}}</p>
    </template>
    <template v-slot:action="{ record }">
      <a v-has:storeReviewDetail="()=> {$router.push('/customer/store/storeReviewDetail?type=review&id='+record.id)}" href="javascript:;">审核详情</a>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
</template>

<script>
  import { DownOutlined ,UpOutlined} from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getStoreExamineList } from "@/api/store";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    keyword: "",
    level_id: '',
    type_id: '',
    status: '',
    page: 1,
    limit: 10,
    province_id: '',
    city_id: '',
    area_id: '',
    street: ''
  };
  export default {
    name: "storeList",
    components: {DownOutlined ,UpOutlined},
    props: {
      typeList: {
        type: Array
      },
      levelList: {
        type: Array
      }
    },
    setup(props, ctx) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        open:false,
        listLoading: false,
        time: [],
        total: 1,
        selectedRowKeys: []
      });
      let columns = [
        // {
        //   title: "门店编号",
        //   dataIndex: "store_code",
        //   key: "store_code",
        // },
        {
          title: "门店名称",
          dataIndex: "store_name",
          key: "store_name",
        },
        {
          title: "门店地址",
          dataIndex: "address",
          key: "address",
        },
        {
          title: "手机号码",
          dataIndex: "clerk_phone",
          key: "clerk_phone",
        },
        {
          title: "负责人",
          dataIndex: "clerk_name",
          key: "clerk_name",
        },
        {
          title: "门店级别/类型",
          key: "type",
          slots: { customRender: "type" },
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };

      // 选择省市区
      const citychange = (e) => {
        search.value.province_id = e[0]
        search.value.city_id = e[1]
        search.value.area_id = e[2]
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getStoreExamineList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };


      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        initData(search.value);

      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        citychange
      };
    },
  };
</script>
